import {connectRefinementList} from 'instantsearch.js/es/connectors';

const renderCustomBrandOverview = (renderOptions, isFirstRender) => {
    const {
        items,
        widgetParams,
    } = renderOptions;

    var alphabetArray = [];
    alphabetArray['#'] = [];
    for (var i = 0; i < 26; i++) {
        alphabetArray[String.fromCharCode(i + 97)] = [];
    }

    if (isFirstRender) {
        const alphabetDiv = document.createElement('div');
        alphabetDiv.className = 'row col-12 alphabet';
        alphabetDiv.id = 'alphabet';
        widgetParams.container.appendChild(document.createElement('hr'));
        widgetParams.container.appendChild(alphabetDiv);
        widgetParams.container.appendChild(document.createElement('hr'));

        const brandsDiv = document.createElement('div');
        brandsDiv.id = 'brands';
        widgetParams.container.appendChild(brandsDiv);
        widgetParams.container.appendChild(document.createElement('hr'));
    }

    let minCountOfProducts = 1
    try {
        minCountOfProducts = parseInt(widgetParams.minCountOfProducts);
    } catch {
    }

    items.map(function (item) {
        if (item.count >= minCountOfProducts) {
            if (!isNaN(item.value.charAt(0).toLowerCase())) {
                alphabetArray['#'].push(item);
            } else {
                alphabetArray[item.value.charAt(0).toLowerCase()].push(item);
            }
        }
    });

    let alphabetHtml = ``;
    let brandsHtml = ``;
    Object.keys(alphabetArray).forEach(key => {
        if (alphabetArray[key].length > 0) {
            alphabetHtml += `<div class="letter"><a href="#${key.toUpperCase()}">${key.toUpperCase()}</a></div>`;

            let brandItemHtml = ``;
            alphabetArray[key].forEach((item) => {
                let value = item.value.split(';');
                if (value.length === 2) {
                    brandItemHtml += `<div class="brands-list-item col-12 col-md-4"><a href="${value[1]}">${value[0]}</a></div>`;
                }
            });

            brandsHtml += `<div id="${key.toUpperCase()}" class="row letter-switch">
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="brands-title col-12">${key.toUpperCase()}</div>
                        ${brandItemHtml}
                    </div>
                </div>
            </div>`;

        } else {
            alphabetHtml += `<div class="letter disabled">${key.toUpperCase()}</div>`;
        }

        widgetParams.container.querySelector('#alphabet').innerHTML = alphabetHtml;
        widgetParams.container.querySelector('#brands').innerHTML = brandsHtml;
    });
};

// 2. Create the custom widget
const customBrandOverview = connectRefinementList(
    renderCustomBrandOverview
);

export {customBrandOverview};
